import { useEffect } from "react";
import { ArrayInput, Edit, SimpleForm, SimpleFormIterator, TextInput, useDataProvider, useNotify } from "react-admin";

export const EventTypeList = () => {
  const dataProvider = useDataProvider();
  useEffect(() => {
    dataProvider
      .getListEventType()
      .then(({ data }) => {
        window.location.href = "/admin/#/event-type/" + data[0].id;
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return <></>;
};

export const EventTypeEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic">
      <SimpleForm>
        <ArrayInput source="values">
          <SimpleFormIterator>
            <TextInput label="Value" source="name" fullWidth />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};
